import { useState, useCallback } from 'react';
import axios from 'axios';
import { validateRegistrationForm, EMPTY_FORM } from './registrationForm';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Handles registration for a FREE demo class (no payment). The lead is stored
 * server-side so counsellors can follow up.
 */
export function useRegistrationPayment() {
  const [form, setForm] = useState({ ...EMPTY_FORM });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const updateField = useCallback((key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  }, []);

  const reset = useCallback(() => {
    setSuccess(null);
    setError('');
    setForm({ ...EMPTY_FORM });
  }, []);

  const pay = useCallback(async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError('');

    const validationError = validateRegistrationForm(form);
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/registrations/free`, form);
      setSuccess({
        registrationId: data.registration_id,
        name: form.name,
      });
    } catch (err) {
      console.error('Free registration failed:', err);
      setError(err?.response?.data?.detail || 'Something went wrong. Please try again in a moment or call us directly.');
    } finally {
      setLoading(false);
    }
  }, [form]);

  return { form, loading, error, success, updateField, pay, reset };
}
